import rightsAndResponsibilities2013 from '../assets/documents/Rights-and-Responsibilities-2013.pdf'

export default {
    rightsAndResponsibilities2013
}
